import React, { Fragment } from 'react';
import styles from './styles.module.less';
import PropTypes from 'prop-types';
import { Divider } from 'antd';

const FMPersonalDetailsCard = ({ rows }) => (
  <div className={styles.wrapper}>
    <div className={styles.title}>Do these details look right to you?</div>

    <div className={styles.rows}>
      {rows.map((row, index) => {
        const isLastItem = index === rows.length - 1;

        return (
          <Fragment key={index}>
            <div className={styles.row}>
              <div className={styles.label}>{row.label}</div>
              <div className={styles.value}>{row.value}</div>
            </div>
            {!isLastItem && <Divider className={styles.divider} />}
          </Fragment>
        );
      })}
    </div>
  </div>
);

FMPersonalDetailsCard.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default FMPersonalDetailsCard;
